var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppVersionFilterIcon = function SvgAppVersionFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8351 15L16.8351 20C17.6631 20.828 19.0071 20.828 19.8351 20C20.6631 19.172 20.6631 17.828 19.8351 17L14.8351 12",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.916 5.84699C20.94 5.86999 20.958 5.89999 20.967 5.93199C21.437 7.49899 21.073 9.26199 19.835 10.5C18.584 11.751 16.797 12.109 15.218 11.617L6.87104 19.964C6.05804 20.777 4.73204 20.838 3.89104 20.054C3.00704 19.231 2.98904 17.847 3.83504 17L12.218 8.61699C11.726 7.03799 12.084 5.25099 13.335 3.99999C14.573 2.76199 16.336 2.39799 17.903 2.86799C17.935 2.87799 17.965 2.89499 17.988 2.91899L18.15 3.08099C18.228 3.15899 18.228 3.28599 18.15 3.36399L15.515 5.99999L17.835 8.31999L20.471 5.68399C20.549 5.60599 20.676 5.60599 20.754 5.68399L20.916 5.84699V5.84699Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93304 4.29302L3.60704 6.31602C3.74304 6.72502 4.12504 7.00002 4.55604 7.00002H6.83504V4.72102C6.83504 4.29102 6.56004 3.90802 6.15104 3.77202L4.12804 3.09802C3.94804 3.03802 3.75004 3.08502 3.61604 3.21902L3.05404 3.78102C2.92004 3.91502 2.87304 4.11302 2.93304 4.29302V4.29302Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84009 7L10.3401 10.5",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgAppVersionFilterIcon as ReactComponent };
export default __webpack_public_path__ + "app-version-filter-icon.svg";